import { SubscriptionContractStatus } from "@cabal/shared/domain/billing/subscription/enums.js";
import type { useSubscription } from "@/contexts/subscription";

type SubscriptionData = ReturnType<typeof useSubscription>["data"];

export function getHasActiveSubscription(
  subscriptionData: SubscriptionData,
): boolean {
  return subscriptionData?.contract.status === SubscriptionContractStatus.Active;
}
